
const colors = {
  purple: '#251738',
  cyan: '#24ddd8',
  white: '#f0eaf4',
  pink: '#ffa4cd',
  yellow: '#f9d673'
}
export default colors;
